import { TEMPLATES_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import templatesTypes from '../../constants/templatesTypes'
import { axios } from '../../services'

// 1 delete
const delete_template_request = () => {
  return {
    type: templatesTypes.publish.request
  }
}

const delete_template_success = (response) => {
  return {
    type: templatesTypes.publish.success,
    payload: response.data
  }
}

const delete_single_template_success = (response) => {
  return {
    type: templatesTypes.publish.single,
    payload: response.data
  }
}

const delete_template_failure = (messages) => {
  return {
    type: templatesTypes.publish.failure,
    payload: messages
  }
}

const delete_template = (template_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( delete_template_request() )
    const reqParams = index ? {
      index: index,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: index}
    // Request
    axios.delete(
      formatRoute(TEMPLATES_ROUTES.destroy, {id: template_id}),
      {
        params: reqParams
      }
    ).then( response => {
      window.showSnackbar('success', 'The template has been permanently deleted.')
      if ( index ) {
        dispatch( delete_template_success(response) )

      } else {
        dispatch( delete_single_template_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error deleting template"]
      }
      dispatch( delete_template_failure( errors ) )
    })
  }
}

export {delete_template}



// WEBPACK FOOTER //
// ./src/js/actions/templates/delete.js